import request from '@/utils/request'

// 获取游戏列表
export function game_list() {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/SelfProtectiveOp/game_list.do',
    method: 'get'
  })
}

// 获取区组列表
export function zone_list(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/SelfProtectiveOp/zone_list.do',
    method: 'post',
    data
  })
}

// 提交冻结申请
export function freeze_apply(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/SelfProtectiveOp/freeze/apply.do',
    method: 'post',
    data
  })
}

// 提交解冻申请
export function unfreeze_apply(data) {
  return request({
    url: process.env.VUE_APP_BASE_API_HELPER + '/SelfProtectiveOp/unfreeze/apply.do',
    method: 'post',
    data
  })
}
